import { render, staticRenderFns } from "./info-invitations.vue?vue&type=template&id=6ab25804&scoped=true&"
import script from "./info-invitations.vue?vue&type=script&lang=js&"
export * from "./info-invitations.vue?vue&type=script&lang=js&"
import style0 from "./info-invitations.vue?vue&type=style&index=0&id=6ab25804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab25804",
  null
  
)

export default component.exports